export default __webpack_public_path__ + "static/media/eye-on.e6200299.svg";